import TechnicalIcon from '@mui/icons-material/Handyman';
import ProvisionsIcon from '@mui/icons-material/Restaurant';
import InteriorsIcon from '@mui/icons-material/Yard';
import ConciergeIcon from '@mui/icons-material/ConfirmationNumber';
import DepotIcon from '@mui/icons-material/Webhook';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import PeopleIcon from '@mui/icons-material/People';
import CampaignIcon from '@mui/icons-material/Campaign';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import ComputerIcon from '@mui/icons-material/Computer';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import InventoryIcon from '@mui/icons-material/Inventory';
import SailingIcon from '@mui/icons-material/Sailing';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WineBarIcon from '@mui/icons-material/WineBar';
import SpaIcon from '@mui/icons-material/Spa';

export const getApiPath = (yachtID) =>
  `/yachts/${yachtID}?populate[id_yacht_members][populate][id_users_permissions_user]=%2A&
  [populate][id_booking][populate][id_marina]=%2A&
  [populate][id_booking][sort][0]=check_in_date:desc&
  [populate][id_attendance][populate][id_provenence_list][populate][provenence_group]=%2A&
  [populate][id_attendance][populate][id_provenence_list][populate][provenence_sales_channel]=%2A&
  [populate][id_operation_lists][populate][id_user_in_charge][populate][id_users_permissions_user][fields]=name,surname&
  [populate][id_operation_lists][populate][id_marina]=%2A&
  [populate][id_operation_lists][populate][id_reservation]=%2A&
  [populate][id_operation_lists][populate][id_department]=%2A&
  [populate][id_operation_lists][populate][id_service]=%2A&
  [populate][id_operation_lists][populate][id_shipping][populate][id_shipping_type]=%2A&
  [populate][id_operation_lists][populate][id_list][populate][id_list_items][populate][id_item]=%2A&
  [populate][id_operation_lists][populate][id_list][populate][id_list_items][populate][id_logbook][populate][id_supplier]=%2A&
  [populate][id_operation_lists][sort][0]=requested_date:desc&
  [populate][id_logbooks][sort][0]=collection_delivery_date:desc&
  [populate][id_logbooks][sort][1]=collection_delivery_time:desc&
  [populate][id_logbooks][populate][id_department]=%2A&
  [populate][id_logbooks][populate][id_supplier]=%2A&
  [populate][id_logbooks][populate][id_delivery_note]=%2A&
  [populate][id_logbooks][populate][id_list_items][populate][id_list][populate][id_delivery_note]=%2A&
  [populate][id_attendance][populate][id_agent_NA][populate][id_users_permissions_user][fields][0][1]=name,surname&
  populate[yacht_document][populate]=%2A&
  populate[id_flag]=%2A&
  populate[id_nautica_known]=%2A`.replace(/\s+/g, '');

export const isValidDate = (value) => {
  if (!value) return false;
  const date = value instanceof Date ? value : new Date(value);
  return !isNaN(date.getTime());
};

export const getRangeDateFilters = (startDate, endDate) => {
  return [
    {
      type: 'id_operation_lists',
      key: 'requested_date',
      operator: '$gte',
      date: startDate,
    },
    {
      type: 'id_operation_lists',
      key: 'requested_date',
      operator: '$lte',
      date: endDate,
    },
    {
      type: 'id_attendance',
      key: 'registration_date',
      operator: '$gte',
      date: startDate,
    },
    {
      type: 'id_attendance',
      key: 'registration_date',
      operator: '$lte',
      date: endDate,
    },
    {
      type: 'id_booking',
      key: 'check_in_date',
      operator: '$lte',
      date: endDate,
    },
    {
      type: 'id_booking',
      key: 'check_out_date',
      operator: '$gte',
      date: startDate,
    },
    {
      type: 'id_logbooks',
      key: 'collection_delivery_date',
      operator: '$gte',
      date: startDate,
    },
    {
      type: 'id_logbooks',
      key: 'collection_delivery_date',
      operator: '$lte',
      date: endDate,
    },
  ];
};
export const getTodayDateFilters = (today) => {
  return [
    {
      type: 'id_operation_lists',
      key: 'requested_date',
      operator: '$eq',
      date: today,
    },
    {
      type: 'id_attendance',
      key: 'registration_date',
      operator: '$eq',
      date: today,
    },
    { type: 'id_booking', key: 'check_in_date', operator: '$eq', date: today },
  ];
};

export const departmentIcons = {
  AGENCY: <DirectionsBoatIcon />,
  CONCIERGE: <ConciergeIcon />,
  DEPOT: <DepotIcon />,
  ENOTECA: <WineBarIcon />,
  INTERIORS: <InteriorsIcon />,
  PROVISIONS: <ProvisionsIcon />,
  SHIPPING: <LocalShippingIcon />,
  TECHNICAL: <TechnicalIcon />,
  MAGAZZINO: <WarehouseIcon />,
  DRIVERS: <DriveEtaIcon />,
  DELIVERIES: <InventoryIcon />,
  'HUMAN RESOURCES': <PeopleIcon />,
  MARKETING: <CampaignIcon />,
  MAINTAINANCE: <BuildCircleIcon />,
  IT: <ComputerIcon />,
  DIRECTION: <AccountTreeIcon />,
  ADMIN: <AdminPanelSettingsIcon />,
  'MARITIME AGENCY': <SailingIcon />,
  SALES: <TrendingUpIcon />,
  'HABIBI TAKE CARE': <SpaIcon />,
};

export const departmentColors = {
  AGENCY: '#00568d',
  CONCIERGE: '#1dc6c2',
  DEPOT: '#ffc107',
  INTERIORS: '#fc559e',
  PROVISIONS: '#86e69f',
  SHIPPING: '#535252',
  TECHNICAL: '#2b8bc8',
  DEFAULT: '#f5f5f5',
  DEFAULT_TAB: 'rgb(164, 174, 220)',
};

export const defaultChipColor = {
  backgroundColor: '#e0e0e0',
  color: '#616161',
};

export const COLOR_TAB_BOOKING = '#c8e6c9';
